import axios from "../utils/fetch";

/**
 * 搜索座标附近的地理位置信息。
 * http://schedulepost.dev.apphi.com/api/docs/#!/instagram/Instagram_get_locations
 * @param lat 纬度，必填。
 * @param lng 经度，必填。
 * @param q 地名关键词
 * @returns {*}
 */
export function location({ q, cancelToken, accessToken }) {
  return axios.get("https://graph.facebook.com/pages/search", {
    params: {
      q,
      fields: "id,name,location,link",
      access_token: accessToken,
    },
    cancelToken,
  });
}

/**
 * 獲取instagram 用户信息
 * @param q 查询条件
 * @returns {*}
 */
export function searchInsUsers({ q, cancelToken }) {
  return axios.get("instagram/users", {
    params: {
      q,
    },
    cancelToken,
  });
}

/**
 * 查询product
 * @param q 查询条件
 * @param next_id 请求下一组数据
 */
export function searchProduct({ q, next_id }) {
  return axios.get("instagram/products", {
    params: {
      q,
      next_id,
    },
  });
}

/**
 * 获取top信息
 * @param q 查询条件
 * @param lat 坐标
 * @param lng 坐标
 * @returns {*}
 */
export function searchTop({ q, lat, lng, cancelToken }) {
  return axios.get("instagram/top", {
    params: {
      q,
      lat,
      lng,
    },
    cancelToken,
  });
}

/**
 * 获取tag信息
 * @param q 查询条件
 * @returns {*}
 */
export function searchTag({ q, cancelToken }) {
  return axios.get("instagram/tags", {
    params: {
      q,
    },
    cancelToken,
  });
}

/**
 * 查询tag详情信息
 * @param 唯一标识
 * @returns {*}
 */
export function tagMedias({ id, next_id }) {
  return axios.get(`instagram/tags/${id}/medias`, {
    params: { next_id },
  });
}

/**
 * 查询people详情信息
 * @param 唯一标识
 * @returns {*}
 */
export function locationMedias({ id, next_id }) {
  return axios.get(`instagram/locations/${id}/medias`, {
    params: { next_id },
  });
}

/**
 * 获取用户详细信息
 * @param vr 查询条件
 * @returns {*}
 */
export function userDetail({ vr }) {
  return axios.get(`instagram/users/${vr}`);
}

/**
 * 获取ins已发布图片
 * http://schedulepost.dev.apphi.com/api/docs/#!/instagram/Instagram_get_user_medias
 * @param uid ins 用户Id
 * @param accessToken ins token
 * @returns {*}
 */
export function userMedias({ uid, accessToken }) {
  return axios.get(`https://graph.facebook.com/${uid}/media`, {
    params: {
      access_token: accessToken,
      fields: "media_type,media_url,thumbnail_url",
    },
  });
}
/**
 * 获取ins已发布图片
 * http://schedulepost.dev.apphi.com/api/docs/#!/instagram/Instagram_get_user_medias
 * @param uid ins 用户Id
 * @param accessToken ins token
 * @returns {*}
 */
export function publisherDetail({ uid, accessToken }) {
  return axios.get(`https://graph.facebook.com/v3.2/${uid}`, {
    params: {
      access_token: accessToken,
      fields: "followers_count,follows_count,media_count,profile_picture_url",
    },
  });
}
/**
 * 获取ins已发布图片详情
 * https://developers.facebook.com/docs/instagram-api/reference/ig-media
 * @param mediaId 图片对应id
 * @param accessToken ins token
 * @returns {*}
 */
export function userMediaDetail({ mediaId, accessToken }) {
  return axios.get(`https://graph.facebook.com/v10.0/${mediaId}`, {
    params: { access_token: accessToken, fields: "media_type,media_url" },
  });
}
/**
 * 获取指定Ins用户的story信息
 * @param uid
 */
export function userStories({ uid }) {
  return axios.get(`instagram/users/${uid}/stories`);
}

/**
 * 返回与用户相关的 Instagram 图片/视频推荐。
 * @param nextId 查询偏移
 */
export function explore({ next_id }) {
  return axios.get(`instagram/explore`, {
    params: { next_id },
  });
}

/**
 * 保存media
 * @param medoa_id 保存的media_id
 */
export function mediaSave({ media_id }) {
  return axios.post(`instagram/medias/saved`, { media_id });
}

/**
 * 取消保存
 */
export function delMediaSaved({ media_ids }) {
  return axios.delete(`instagram/medias/saved`, {
    data: { media_ids },
  });
}
